import { useEffect, useState } from "react";

import { useTheme } from "styled-components";

import PlatformAvatar from "Images/platform-avatar.svg";
import UpsunAvatarDark from "Vendor_resources/images/logo-ui-dark.svg";
import UpsunAvatarLight from "Vendor_resources/images/logo-ui.svg";

import type { Organization } from "@packages/client";

export function useGetUserAvatar({
  user,
  organization
}: {
  user: { id: string };
  organization?: Organization;
}) {
  const theme = useTheme();
  const [avatarPicture, setAvatarPicture] = useState("");

  const upsunAvatar =
    theme.name === "dark" ? UpsunAvatarDark : UpsunAvatarLight;

  useEffect(() => {
    if (!user) return;
    const isAdmin = user.id === "admin";

    const chosenAvatar =
      organization?.vendor === "upsun" ? upsunAvatar : PlatformAvatar;

    if (isAdmin) setAvatarPicture(chosenAvatar);
  }, [user, organization?.vendor, theme, upsunAvatar]);

  return avatarPicture;
}
